import clsx from "clsx";
import {
  FaInstagram,
  FaPinterest,
  FaTiktok,
  FaTwitter,
  FaYoutube,
  SiFacebook,
} from "@pkg/icons";
import socialLinks from "../../../data/socialLinks";

interface Props extends React.DetailedHTMLProps<
  React.HTMLAttributes<HTMLDivElement>,
  HTMLDivElement
> {
  iconClassName: string;
}

const SocialLinks: React.FC<Props> = ({ className = "", iconClassName }) => (
  <div
    className={clsx(
      "flex space-x-3 py-[42px] text-suvaGrey md:py-0",
      className,
    )}
  >
    <a href={socialLinks.facebook} target="_blank" rel="noopener">
      <SiFacebook className={clsx("2xl:h-3 2xl:w-3", iconClassName)} />
    </a>
    <a href={socialLinks.pinterest} target="_blank" rel="noopener">
      <FaPinterest className={clsx("2xl:h-3 2xl:w-3", iconClassName)} />
    </a>
    <a href={socialLinks.twitter} target="_blank" rel="noopener">
      <FaTwitter className={clsx("2xl:h-3 2xl:w-3", iconClassName)} />
    </a>
    <a href={socialLinks.instagram} target="_blank" rel="noopener">
      <FaInstagram className={clsx("2xl:h-3 2xl:w-3", iconClassName)} />
    </a>
    <a href={socialLinks.youtube} target="_blank" rel="noopener">
      <FaYoutube className={clsx("2xl:h-3 2xl:w-3", iconClassName)} />
    </a>
    <a href={socialLinks.tiktok} target="_blank" rel="noopener">
      <FaTiktok className={clsx("2xl:h-3 2xl:w-3", iconClassName)} />
    </a>
  </div>
);

export default SocialLinks;
